<template>
  <div>
    <modal
      class="device-embedded-information-bach-edit-modal"
      width="460px"
      :backdrop="false"
      :value="showModal"
      effect="fade"
      @closed="closed"
    >
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
            <strong>一括編集</strong>
        </h4>
      </div>
      <div
        class="modal-body device-embedded-information-bach-edit-modal-body"
        style="height: 600px;padding: 0px 15px; overflow-x: auto;"
      >
      <div>
        <div class="form-group ">
          <label class="control-label">編集する項目：</label>
          <input
            ref="local_value"
            style="margin-top:10px;"
            type="text"
            class="form-control"
            v-on:input="updateValue($event.target.value)"
            id="local_value"
            name="local_value"
            v-bind:value="localValue"
            placehold
            er
            />
        </div>
        <div class="form-group ">
          <label class="control-label">編集内容：</label>
          <input
            ref="local_value"
            style="margin-top:10px;"
            type="text"
            class="form-control"
            v-on:input="updateValue($event.target.value)"
            id="local_value"
            name="local_value"
            v-bind:value="localValue"
            placehold
            er
            />
        </div>
     </div>
                <div class="form-group ">
          <label class="control-label">編集する項目2：</label>
          <input
            ref="local_value"
            style="margin-top:10px;"
            type="text"
            class="form-control"
            v-on:input="updateValue($event.target.value)"
            id="local_value"
            name="local_value"
            v-bind:value="localValue"
            placehold
            er
            />
        </div>
                <div class="form-group ">
          <label class="control-label">編集内容：</label>
          <input
            ref="local_value"
            style="margin-top:10px;"
            type="text"
            class="form-control"
            v-on:input="updateValue($event.target.value)"
            id="local_value"
            name="local_value"
            v-bind:value="localValue"
            placehold
            er
            />
        </div>
                <div class="form-group ">
          <label class="control-label">編集する項目3：</label>
          <input
            ref="local_value"
            style="margin-top:10px;"
            type="text"
            class="form-control"
            v-on:input="updateValue($event.target.value)"
            id="local_value"
            name="local_value"
            v-bind:value="localValue"
            placehold
            er
            />
        </div>
                <div class="form-group ">
          <label class="control-label">編集内容：</label>
          <input
            ref="local_value"
            style="margin-top:10px;"
            type="text"
            class="form-control"
            v-on:input="updateValue($event.target.value)"
            id="local_value"
            name="local_value"
            v-bind:value="localValue"
            placehold
            er
            />
        </div>
      </div>
      <button type="button" class="btn btn-default">編集項目追加</button>
      <div slot="modal-footer" class="modal-footer" style="background:white">

        <button type="button" class="btn btn-default" @click="closed('no')">戻る</button>
        <button type="button" class="btn btn-primary" @click="closed('yes')">申請</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
var vm = this;

import modal from "./local-modal";

Vue.component("modal", modal);
import _ from "lodash";
import debug from "debug";
var debug_input_manual = debug("esma:input-modal");

export default {
  data() {
    return {
      show_modal: false,
      title_label: "",
      callback: null,
      local_value: ""
    };
  },
  computed: {
    localValue: {
      get() {
        return this.local_value;
      },
      set(v) {
        console.log("showModalWindow Set localValue", v);
        this.local_value = v;
      }
    },
    showModal() {
      return this.show_modal;
    }
  },
  methods: {
    updateValue(val) {
      this.localValue = val;
      this.$emit("inputed", this.localValue);
    },
    onShow() {},
    showModalWindow(data) {

      this.onShow();
      this.localValue = data.initial_value || "";
      this.show_modal = true;
      this.$refs.local_value.focus();
      setTimeout(() => {
        this.$refs.local_value.focus();
      }, 100);
    },
    closed(mode) {
      if (mode == "yes") {
        this.$emit("save", this.localValue);
      }
      this.$emit("closed", this.localValue);
      this.show_modal = false;
    }
  },
  props: {
    tag: { type: String, default: "showDeviceEmbeddedInformationBachEditModal" }
  },
  mounted() {
    debug_input_manual("On mounted");
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// device-embedded-information-bach-edit-modal.vue?24970032